import React, { useState } from "react";
import { makeStyles } from "@mui/styles";
import { withStyles } from "@mui/styles";
import Button from "components/CustomButtons/Button.js";
import Dialog from "@mui/material/Dialog";
import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";
import MuiDialogContent from "@mui/material/DialogContent";
import MuiDialogActions from "@mui/material/DialogActions";
import AddIcon from '@mui/icons-material/Add';
import Tooltip from "@mui/material/Tooltip";
import CustomDialogTitle from "components/Dialog/CustomDialogTitle.js";

const DialogContent = withStyles((theme) => ({
  root: {
    padding: '16px',
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: '8px',
  },
}))(MuiDialogActions);

const useStyles = makeStyles(styles);

export default function UploadData(props) {
  const classes = useStyles();
  const {
    open,
    handleClickOpen,
    handleClose,
    buttonTitle,
    dialogTitle,
    content,
  } = props;

  return (
    <div>
      <Tooltip title={buttonTitle}>
        <Button
          onClick={handleClickOpen}
          color={"success"}
          className={classes.actionButton}
        >
          <AddIcon fontSize="large" />
        </Button>
      </Tooltip>
      <Dialog
        onClose={handleClose}
        aria-labelledby="adduser-dialog-title"
        fullWidth="true"
        maxWidth="sm"
        open={open}
      >
        <CustomDialogTitle id="addMarket-dialog-title" onClose={handleClose}>
          {dialogTitle}
        </CustomDialogTitle>
        <DialogContent dividers>
          {content}
        </DialogContent>
        <DialogActions></DialogActions>
      </Dialog>
    </div>
  );
}
